import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Login from './components/Login.vue';
import PageNotFound from './components/PageNotFound.vue';
import UserComponent from './components/UserComponent.vue';
import GroupComponent from './components/GroupComponent.vue';
import PreferencesComponent from './components/PreferencesComponent.vue';
import FormConfigureComponent from './components/FormConfigureComponent.vue';
import FormListsComponent from './components/FormListComponent.vue';
import FormSummarizeComponent from './components/FormSummarizeComponent.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        layout: 'Backend',
      },
    },
    {
      path: '/preferences',
      name: 'preferences',
      component: PreferencesComponent,
      meta: {
        layout: 'Backend',
      },
    },
    {
      path: '/form/configure',
      name: 'form-configure',
      component: FormConfigureComponent,
      meta: {
        layout: 'Backend',
      },
    },
    {
      path: '/form/list',
      name: 'form-list',
      component: FormListsComponent,
      meta: {
        layout: 'Backend',
      },
    },
    {
      path: '/form/sum',
      name: 'form-sum',
      component: FormSummarizeComponent,
      meta: {
        layout: 'Backend',
      },
    },
    {
      path: '/manage/user',
      name: 'user',
      component: UserComponent,
      meta: {
        layout: 'Backend',
      },
    },
    {
      path: '/manage/group',
      name: 'group',
      component: GroupComponent,
      meta: {
        layout: 'Backend',
      },
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        layout: 'Default',
      },
    },
    {
      path: '*',
      name: '404',
      component: PageNotFound,
      meta: {
        layout: 'Default',
      },
    },
  ],
});
